import img1 from '/static/img/experience/traffic/swiper/img1.png'
import img2 from '/static/img/experience/traffic/swiper/img2.png'
import img3 from '/static/img/experience/traffic/swiper/img3.png'
import img4 from '/static/img/experience/traffic/swiper/img4.png'
import img5 from '/static/img/experience/traffic/swiper/img5.png'

const swiperList = [
    {
        id: 1,
        img:img1,
        title: 'Gulfstream 450',
        desc: 'It is the most spacious long-range business jet in its class, with robust transcontinental flight and climb capabilities. Equipped with Gulfstream\'s exclusive PlaneView cockpit and Enhanced View system.',
    },
    {
        id: 2,
        img:img2,
        title: 'Gulfstream 550',
        desc: 'One of the representative models of long-range jet business jets, it is a luxury business jet with long range, excellent performance, spacious cabin and good comfort.',
    },
    {
        id: 3,
        img:img3,
        title: 'Dassault Falcon 7X',
        desc: 'The F7X features subtle curves throughout the cabin interior that enhance the sense of spaciousness, space and comfort. It\'s perfect for business negotiations and parties.',
    },
    {
        id: 4,
        img:img4,
        title: 'cabin service',
        desc: 'Different aircraft models are equipped with different entertainment facilities and exquisite meals; microwave ovens, coffee machines, DVDs, toiletries bags, etc.',
    },
    {
        id: 5,
        img:img5,
        title: 'experienced staff&crew',
        desc: 'Enjoy first-class service during your flight, provided by professional flight attendants with years of experience.',
    },
    
]

export default {
    swiperList
}